/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2017-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

/**
* Directive that will handle the rotation of image-blocks, and image-carousel-blocks.
*/
angular.module('bulbApp.contentEditorModule')
  .directive('bulbRotatable', [
    '$',
    '$log',
    '$timeout',
    'Restangular',
    'BulbAutoSaveService',
    'BulbBusyService',
    'SerialSaveService',
    'UnitStateStore',
    'ASSET_LIBRARY',
    'CONTENT_EDITOR',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    bulbRotatable,
  ]);

function bulbRotatable(
  $,
  $log,
  $timeout,
  Restangular,
  BulbAutoSaveService,
  BulbBusyService,
  SerialSaveService,
  UnitStateStore,
  ASSET_LIBRARY,
  CONTENT_EDITOR,
) {
  return {
    require: ['^?mediumContentEditor', '^contentBlock', '^bulbFrame', '^?imageBlock', '^?imageCarousel'],
    link(scope, elem, attrs, ctrls) {
      const [contentEditorCtrl] = ctrls;
      if (contentEditorCtrl && !contentEditorCtrl.page.editing) {
        return;
      }

      const contentBlockCtrl = ctrls[1];
      const imageBlockCtrl = ctrls[3];
      const imageCarouselBlockCtrl = ctrls[4];

      let rotationDegree = ASSET_LIBRARY.ROTATE.INITIAL_START_DEGREE;
      let unmodifiedRotationDegree = ASSET_LIBRARY.ROTATE.INITIAL_START_DEGREE;

      const currentBlockType = contentBlockCtrl.contentBlock.blockType;

      let enabled = false;

      let imageElement = null;
      /**
       * This block of code correctly grabs the current image so that we can pass it to cropperJs.
       * It is simple for image blocks, however for image-carousel blocks -- it is a little more involved.
       * This is because the user can dynamically add or remove images. So how do we always grab the correct one?
       * By essentially watching the contentBlock and check the currently displayed image id's.
       */
      if (currentBlockType === 'IMAGE') {
        $timeout(() => {
          imageElement = elem.find('img');
        }, CONTENT_EDITOR.IMAGE_ASSET.IMAGE_ASSET_IMAGE_TIMEOUT);
      } else if (currentBlockType === 'IMAGE_CAROUSEL') {
        scope.$watchCollection('contentBlockCtrl.contentBlock', (newValue) => {
          // Update the displayedImageAssetUrl to reflect the correct image url
          $timeout(() => {
            try {
              const imageAsset = newValue.carouselImages[
                contentBlockCtrl.contentBlock.displayedImageIndex].uncroppedImageAsset
                || newValue.carouselImages[contentBlockCtrl.contentBlock.displayedImageIndex].fullImageAsset;
              imageElement = $(`img[id="${imageAsset.id}"]`);
            } catch (error) {
              // During a carousel state re-init, it is possible that
              // contentBlockCtrl.contentBlock.displayedImageIndex doesn't have a value and thus will
              // throw an error on the client. This isn't necessarily bad, however I don't want an error
              // thrown in the console so that is why we do in this case.
            }
          }, CONTENT_EDITOR.CAROUSEL.CAROUSEL_GRAB_IMAGE_TIMEOUT);
        });
      } else {
        $log.error('currentBlockType is an undefined type.');
      }

      function initRotate() {
        let rotatedImageAsset = null;
        if (currentBlockType === 'IMAGE') {
          rotatedImageAsset = contentBlockCtrl.contentBlock.rotatedImageAsset
            || contentBlockCtrl.contentBlock.scaledImageAsset;
          imageBlockCtrl.updateImageInfo(rotatedImageAsset);
        } else if (currentBlockType === 'IMAGE_CAROUSEL') {
          const carouselImage = contentBlockCtrl.contentBlock.carouselImages[
            contentBlockCtrl.contentBlock.displayedImageIndex];
          rotatedImageAsset = carouselImage.scaledImageAsset || carouselImage.fullImageAsset;
          // Is this broken?  We never update the carousel like we do the image in the if block above.
        } else {
          $log.error('currentBlockType is an undefined type.');
        }

        elem.addClass('bulb-rotating');

        // This is a workaround for iOS that also works on all other platforms. On iOS (specifically iPhones)
        // the selected element is de-selected when the user clicks the toolbar, this results in the updateToolbar()
        // method failing. Here we know we are in the beginning of the crop, so we directly set the selected element
        // This method handles the state/toolbar update as well.
        contentEditorCtrl.insertBlockExtension.selectBlock(elem);
        scope.$apply();

        enabled = true;
      }

      function rotateStop() {
        elem.removeClass('bulb-rotating');
        if (currentBlockType === 'IMAGE') {
          imageBlockCtrl.updateImageInfo();
        }
        scope.$apply();
        enabled = false;
      }

      scope.$on('command-rotate', () => {
        if (contentBlockCtrl.selected && !enabled) {
          initRotate();
        }

        /**
         * Perform this initial check to check if the *current* element is being rotated. Without this check,
         * any image on the page would be rotated.
         */
        if (elem.hasClass('bulb-rotating')) {
          rotationDegree += ASSET_LIBRARY.ROTATE.CONSTANT_ROTATION_DEGREE;

          unmodifiedRotationDegree += rotationDegree;
          const imageBlockPatch = {
            rotationDegree: (rotationDegree % 360),
            unmodifiedRotationDegree,
          };
          if (currentBlockType === 'IMAGE_CAROUSEL') {
            imageBlockPatch.selectedImageIndex = contentBlockCtrl.contentBlock.displayedImageIndex;
          }
          const index = contentBlockCtrl.contentBlock.displayedImageIndex;

          SerialSaveService.save({
            showBusy: true,
            save: () => Restangular.one('units', contentBlockCtrl.page.unit.id)
              .one(CONTENT_EDITOR.BLOCK_PATHS[currentBlockType], contentBlockCtrl.contentBlock.id)
              .patch(imageBlockPatch)
              .then((modifiedContentBlock) => {
                if (currentBlockType === 'IMAGE') {
                  angular.copy(modifiedContentBlock.plain(), contentBlockCtrl.contentBlock);
                  imageBlockCtrl.updateImageInfo();
                } else if (currentBlockType === 'IMAGE_CAROUSEL') {
                  scope.$emit('rotated-carousel-image', index);
                  imageCarouselBlockCtrl.updateCarouselState(modifiedContentBlock);
                } else {
                  $log.error('currentBlockType is an undefined type.');
                }

                // Update share status to reflect that the page has been edited:
                const ShareTransition = UnitStateStore.getShareTransitionEnum();
                UnitStateStore.transitionShareStatus(ShareTransition.EDIT);
              }),
          }).then(() => {
            // Need to delete this dynamically created css attribute because it messes up the
            // correct rotation for the imageBlock.
            imageElement.css('transform', '');
          });

          /*
          Need to reset the values of counter and rotationDegree after image has
          been saved.
          */
          rotationDegree = ASSET_LIBRARY.ROTATE.INITIAL_START_DEGREE;

          /*
           * This is needed to re-initialize jquery-rotate. Without it, when the user presses the
           * rotate button, jquery-rotate won't register it as an animated click.
           */
          imageElement.rotate({
            angle: rotationDegree,
            animateTo: rotationDegree,
          });
        }
      });

      scope.$on('selectionChange', () => {
        if (!contentBlockCtrl.selected && enabled) {
          rotateStop();
        }
      });
    },
  };
}
